import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useSearchParams, useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../components/BaseUrl";
import { decryptToken } from "../../../Utlis/Encryption";
import { useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
const SubscriptionSuccess = () => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const {t} =useTranslation()
  useEffect(() => {
    const activateSubscription = async () => {
      try {
        const subscription_id = searchParams.get("subscription_id");
        const ba_token = searchParams.get("ba_token");
        const tokenParam = searchParams.get("token");
        const upgradeToken = searchParams.get("upgrade_token");

        console.log("🔍 Extracted Params:", {
          subscription_id,
          ba_token,
          tokenParam,
        });

        if (!subscription_id || !ba_token || !tokenParam) {
          console.error("❌ Missing PayPal redirect data");
       toast.error(t("alerts.invalid_paypal_redirect"));
          return;
        }

        const body = {
          subscription_id,
          ba_token,
          token: tokenParam,
        };

        console.log("📤 Sending POST request to:", `${BASE_URL}/payments/activate-subscription`);
        console.log("📦 Request Body:", body);

        const res = await fetch(`${BASE_URL}/payments/activate-subscription`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
          body: JSON.stringify(body),
        });

        console.log("📥 Response Status:", res.status);
        const data = await res.json();
        console.log("📥 Response Data:", data);

        if (!res.ok) {
          console.error("❌ Activation failed:", data.message);
throw new Error(t("alerts.activation_failed"));
        }

        console.log("✅ Subscription activated successfully!");
toast.success(t("alerts.activation_success"));

         setTimeout(() => {
          navigate("/payment/success", {
            // upgrade_token can be lost across the PayPal redirect round-trip, so
            // also treat "no real logged-in session" as an upgrade-flow signal.
            state: { ...data.data, upgradeFlow: Boolean(upgradeToken) || !token },
          });
        }, 1500);
      } catch (err) {
        console.error("🔥 API Error:", err);
toast.error(err.message || t("alerts.activation_error"));
      } finally {
        setLoading(false);
      }
    };

    activateSubscription();
  }, [searchParams, decryptedToken, navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loading && <CircularProgress />}
    </Box>
  );
};

export default SubscriptionSuccess;
